import React from 'react';
import droneImage from '../cyclone.png';
import profileImage from '../profile.jpg';

const educationData = {
  degree: "BASc Engineering Science",
  major: "Aerospace Engineering",
  minor: "Robotics Engineering",
  university: "University of Toronto",
  graduationYear: "2027"
};

// You can replace this with your actual profile image
// const profileImage = null; // Set to your image path like: import profileImage from '../profile.jpg';

const AboutSection = () => (
  <section 
    id="about" 
    className="py-16 bg-transparent relative"
    >
    {/* Drone Animation */}
    <div className="absolute left-1/2 transform -translate-x-1/2 pointer-events-none z-50 top-[-250px]">
      <div
        className="absolute left-1/2 transform -translate-x-1/2 w-0.5 bg-yellow-400 z-10"
        style={{ top: '80px', height: '240px' }}
      />
      <div
        className="absolute left-1/2 transform -translate-x-1/2 w-8 h-4 bg-gray-600 rounded-b-lg z-20"
        style={{ top: '314px' }}
      />
      <img
        src={droneImage}
        alt="Drone"
        className="min-w-[230px] w-[320px] sm:w-[350px] min-h-[200px] h-[230px] sm:h-[250px] object-contain relative z-20 brightness-110 translate-y-10 sm:translate-y-0"
        style={{ 
          display: 'block', 
          opacity: 1, 
          marginTop: '-50px', 
          marginLeft: '4px'
        }}
        loading="eager"
      />
    </div>

    <div className="max-w-4xl mx-auto px-3 sm:px-4 md:px-6">
      <div className="rounded-2xl bg-gray-800 p-3 sm:p-4 md:p-6 lg:p-8 pb-6 sm:pb-8 md:pb-10 lg:pb-16 shadow-lg border border-gray-700 relative overflow-hidden">
        <div className="text-center mb-6 md:mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">About</h2>
          <div className="w-12 h-0.5 bg-blue-400 mx-auto rounded" />
        </div>
        
        <div className="grid md:grid-cols-3 gap-6 md:gap-8 items-center">
          {/* Profile Image/Logo */}
          <div className="flex justify-center md:col-span-1">
            <div className="relative">
              <div className="w-[160px] h-[187px] md:w-[200px] md:h-[234px] rounded-2xl overflow-hidden shadow-md">
                {profileImage ? (
                  <img 
                    src={profileImage} 
                    alt="Tommy Zhang" 
                    className="w-full h-full object-cover"
                    style={{
                      imageRendering: 'high-quality',
                      imageRendering: '-webkit-optimize-contrast',
                      imageRendering: 'crisp-edges',
                      filter: 'contrast(1.1) saturate(1.05) brightness(1.02)',
                      backfaceVisibility: 'hidden',
                      transform: 'translateZ(0)',
                      WebkitFontSmoothing: 'antialiased',
                      MozOsxFontSmoothing: 'grayscale',
                      textRendering: 'optimizeLegibility',
                      willChange: 'transform'
                    }}
                    loading="eager"
                    decoding="sync"
                  />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                    <div className="text-white text-3xl font-bold">TZ</div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="md:col-span-2 space-y-4 md:space-y-6 flex flex-col justify-center text-center md:text-left" style={{ marginRight: '0px' }}>
            {/* Summary */}
            <div>
              <div className="bg-gray-900 p-3 md:p-4 rounded-lg">
                <p className="text-gray-300 leading-relaxed text-sm md:text-base">
                  Aerospace engineering student passionate about robotics and anything that can fly. 
                  I enjoy building creative solutions that bridge the gap between theory and real-world applications.
                </p>
              </div>
            </div>

            {/* Education */}
            <div>
              <div className="bg-gray-900 p-3 md:p-4 rounded-lg">
                <div className="text-blue-400 font-semibold text-sm md:text-base">{educationData.degree}</div>
                <div className="text-gray-300 text-xs md:text-sm">Major: {educationData.major} | Minor: {educationData.minor}</div>
                <div className="text-gray-400 text-xs mt-2">{educationData.university} • {educationData.graduationYear}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
